import React from "react";

const ChoiceForm = ({
  newChoice,
  setNewChoice,
  handleAddChoice,
  handleKeyPress,
}) => (
  <div className="border">
    <h2>Enter Choices</h2>
    <div className="input-group mb-3">
      <input
        type="text"
        className="form-control"
        value={newChoice}
        onChange={(e) => setNewChoice(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Enter choices separated by commas"
      />
      <div className="input-group-append">
        <button className="btn btn-primary" onClick={handleAddChoice}>
          Add
        </button>
      </div>
    </div>
  </div>
);

export default ChoiceForm;
